import styles from './index.module.less';
import { Alert } from 'antd';

type props = {
  visible: boolean;
  text: string;
  type: 'success' | 'error' | 'warning' | 'info';
  icon?: any;
  style?: any;
};

const UnfinishedMention = (props: props) => {
  const { text, icon, style, type, visible } = props;
  if (visible) {
    return (
      <div style={style || { marginTop: '12px', padding: '0 2px' }}>
        <Alert
          message={
            <div className={styles.alertWrap}>
              <div className={styles.alertIcon}>{icon}</div>
              <div className={styles.alertText}>{text}</div>
            </div>
          }
          type={type}
          closable
          className={styles.alertInfo}
        />
      </div>
    );
  } else {
    return <></>;
  }
};

export default UnfinishedMention;
